import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { useMemo } from 'react';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';

import { persistor, store } from '@store';
import { SFPacklinkProviders } from '@providers';

import { initSentry, configureQueryClient } from '@utils';
import { QueryClientProvider } from '@tanstack/react-query';

initSentry();

function AppWithProviders() {
    const queryClient = useMemo(configureQueryClient, []);

    return (
        <SFPacklinkProviders>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <QueryClientProvider client={queryClient}>
                        <App />
                    </QueryClientProvider>
                </PersistGate>
            </Provider>
        </SFPacklinkProviders>
    );
}

const container = document.getElementById('root');

const root = createRoot(container!);
root.render(<AppWithProviders />);
